// src/context/SystemContext.jsx
// Contexto global para configuración dinámica del sistema: colores de marca, nombre de tema, etc.

import { createContext, useContext, useState, useEffect, useMemo } from 'react';
import { api } from '../api/client';

// Valores por defecto (fallback si la API falla)
const DEFAULT_CONFIG = {
  primaryColor:   '#1F2B68',
  secondaryColor: '#4A5DB7',
  systemName:     'Sistema de Certificados',
  logoUrl:        null,
};

// Contexto
export const SystemContext = createContext(DEFAULT_CONFIG);

// Provider
export function SystemProvider({ children }) {
  const [config, setConfig] = useState(DEFAULT_CONFIG);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Esta petición es pública (sin token) — se ejecuta antes del login
    api.get('/system-configuration/istrue')
      .then((data) => {
        const merged = {
          ...DEFAULT_CONFIG,
          primaryColor:   data.primaryColor   || DEFAULT_CONFIG.primaryColor,
          secondaryColor: data.secondaryColor || DEFAULT_CONFIG.secondaryColor,
          systemName:     data.systemName     || DEFAULT_CONFIG.systemName,
          logoUrl:        data.logoUrl        || null,
        };
        setConfig(merged);
        // Aplicar CSS variables al documento (igual que antes)
        document.documentElement.style.setProperty('--primary-color',   merged.primaryColor);
        document.documentElement.style.setProperty('--secondary-color', merged.secondaryColor);
        document.documentElement.style.setProperty('--color-primary',   merged.primaryColor);
        document.documentElement.style.setProperty('--color-secondary', merged.secondaryColor);
      })
      .catch(() => {
        // Silencioso: se usan los defaults
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  const value = useMemo(() => ({ ...config, isLoading }), [config, isLoading]);

  return (
    <SystemContext.Provider value={value}>{children}</SystemContext.Provider>
  );
}

// Hook de consumo
export function useSystem() {
  return useContext(SystemContext);
}
